module.exports = "https://cdn2-fs.clearscore.com/flux/images/9cab83bc667c07fcae1d6d8118d47cb1.jpg";